//signupstate.js

import { SIGNUP_ACTIONS } from "./signup-actions";

const initialState = {
  fullName: null,
  email: null,
  emailStatus: {
    isOtpSent: false,
    isVerified: false,
    isReadonly: false,
    referenceId: null,
    otp: null,
  },
  phone: null,
  phoneStatus: {
    isOtpSent: false,
    isVerified: false,
    isReadonly: false,
    referenceId: null,
    otp: null,
  },
  password: null,
  confirmPassword: null,
  formLoading: false,
};

const signupReducer = (state=initialState, action) => {
  switch (action.type) { 
    case SIGNUP_ACTIONS.SET_NAME:
      return { ...state, fullName: action.payload };
    case SIGNUP_ACTIONS.SET_EMAIL:
      return { ...state, email: action.payload };
    case SIGNUP_ACTIONS.SET_PHONE:
      return { ...state, phone: action.payload };

    case SIGNUP_ACTIONS.SET_PASSWORD:
      return { ...state, password: action.payload };

    case SIGNUP_ACTIONS.SET_CONFIRM_PASSWORD:
      return { ...state, confirmPassword: action.payload }; 
    case SIGNUP_ACTIONS.EMAIL_OTP_SENT:
      return {
        ...state,
        emailStatus: { ...state.emailStatus, isOtpSent: true,referenceId:action.payload.referenceId,isReadonly:action.payload.isReadonly },
      };

    case "EMAIL_OTP_ENTERED":
      return {
        ...state,
        emailStatus: { ...state.emailStatus, otp: action.payload },
      };
    case SIGNUP_ACTIONS.EMAIL_VERIFICATION_RESET:
      return {
        ...state,
        emailStatus: {
    isOtpSent: false,
    isVerified: false,
    isReadonly: false,
    referenceId: null,
    otp: null,
  }, email:null
      };

    case SIGNUP_ACTIONS.PHONE_VERIFICATION_RESET:
      return {
        ...state,
        phoneStatus: {
    isOtpSent: false,
    isVerified: false,
    isReadonly: false,
    referenceId: null,
    otp: null,
  }, phone:null
      };
    case "EMAIL_OTP_REFERENCE_SET":
      return {
        ...state,
        emailStatus: { ...state.emailStatus, referenceId: action.payload },
      };

    case SIGNUP_ACTIONS.EMAIL_OTP_SET:
      return {
        ...state,
        emailStatus: { ...state.emailStatus, otp: action.payload },
      };

    case SIGNUP_ACTIONS.EMAIL_VERIFIED:
      return {
        ...state,
        emailStatus: { ...state.emailStatus, isVerified: true, isReadonly: true },
      };
 
    case SIGNUP_ACTIONS.PHONE_OTP_SENT:
      return {
        ...state,
        phoneStatus: { ...state.phoneStatus, isOtpSent: true,referenceId:action.payload.referenceId },
      };

    case SIGNUP_ACTIONS.PHONE_OTP_SET:
      return {
        ...state,
        phoneStatus: { ...state.phoneStatus, otp: action.payload },
      };

    case SIGNUP_ACTIONS.EMAIL_OTP_REFERENCE_SET:
      return {
        ...state,
        phoneStatus: { ...state.phoneStatus, referenceId: action.payload },
      };

    // case "PHONE_OTP_SET":
    //   return {
    //     ...state,
    //     phoneStatus: { ...state.phoneStatus, otp: action.payload },
    //   };

    case SIGNUP_ACTIONS.PHONE_VERIFIED:
      return {
        ...state,
        phoneStatus: { ...state.phoneStatus, isVerified: true, isReadonly: true },
      }; 
    case SIGNUP_ACTIONS.SET_FORM_LOADING:
      return { ...state, formLoading: action.payload };
    case SIGNUP_ACTIONS.RESET:
      return initialState;
 
    default:
      return state;
  }
};

export default signupReducer;
